const renderReducer = (state={}, action) => {
    switch (action.type){
        case 'SET_RENDER':{
            let render = state.render? state.render:0
            render = render + 1
            let newState = {render:render}
            return state = newState;
        }
        default : return state
    }
}

export default renderReducer
